import {
  ToitEnPenteConfigurationState,
  ToitEnPenteThermalPerformanceState,
  ToitEnPenteInsulationTypes,
  ToitEnPenteMaterialMap,
  FE_MATERIALS,
  FEMaterial,
  TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS,
} from "@iko-design-center/shared"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { DownloadState } from "./download"
import { initialToitEnPenteState } from "./state"
import { getThermalPerformance, updateThermalLayer } from "./thermalPerformance"

export type ToitEnPenteData = {
  toitInsulation: {
    type: any
    material: FEMaterial | null
  }
  toitClimate: {
    type: any
    material: FEMaterial | null
  }
  toitStructure: {
    type: any
    material: FEMaterial | null
  }
  toitRainCover: {
    type: any
    material: FEMaterial | null
  }
  toitAcousticLayer: {
    type: any
    material: FEMaterial | null
  }
  thermalPerformance: ToitEnPenteThermalPerformanceState
}

export const toitEnPenteSlice = createSlice({
  name: "toitEnPente",
  initialState: initialToitEnPenteState,
  reducers: {
    resetConfiguration: (state) => {
      return {
        ...initialToitEnPenteState,
        download: state.download,
        screenshots: state.screenshots,
      }
    },
    resetConfigurationToClimate: (state) => {
      const draft = {
        ...initialToitEnPenteState,
        download: state.download,
        configuration: {
          ...initialToitEnPenteState.configuration,
          toitInsulation: state.configuration.toitInsulation,
          toitClimate: state.configuration.toitClimate,
        },
        screenshots: state.screenshots,
      }
      return draft
    },
    resetConfigurationToStructure: (state) => {
      const draft = {
        ...initialToitEnPenteState,
        download: state.download,
        configuration: {
          ...initialToitEnPenteState.configuration,
          toitInsulation: state.configuration.toitInsulation,
          toitClimate: state.configuration.toitClimate,
          toitStructure: state.configuration.toitStructure,
        },
        screenshots: state.screenshots,
      }
      return draft
    },
    resetConfigurationToRainCover: (state) => {
      const draft = {
        ...initialToitEnPenteState,
        download: state.download,
        configuration: {
          ...initialToitEnPenteState.configuration,
          toitInsulation: state.configuration.toitInsulation,
          toitClimate: state.configuration.toitClimate,
          toitStructure: state.configuration.toitStructure,
          toitRainCover: state.configuration.toitRainCover,
        },
        screenshots: state.screenshots,
      }
      return draft
    },

    setThermalPerformance: (
      state,
      action: PayloadAction<ToitEnPenteThermalPerformanceState>
    ) => {
      state.thermalPerformance = action.payload
    },
    setToitInsulationType: (state, action: PayloadAction<any>) => {
      const material = FE_MATERIALS.find(
        (material) =>
          material.id ===
          ToitEnPenteMaterialMap[action.payload as ToitEnPenteInsulationTypes]
      )!
      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitInsulation: {
            ...state.configuration.toitInsulation,
            type: action.payload,
            material: material,
          },
        },
      }
      return draft
    },
    setToitInsulationTypeWithThickness: (
      state,
      action: PayloadAction<{ type: any; thickness: string }>
    ) => {
      const { type, thickness: payloadThickness } = action.payload
      const material = FE_MATERIALS.find(
        (material) =>
          material.id ===
          ToitEnPenteMaterialMap[type as ToitEnPenteInsulationTypes]
      )!

      const thickness = isNaN(parseInt(payloadThickness))
        ? 0
        : parseInt(payloadThickness)
      let thicknessIsValid = false
      if (
        thickness &&
        thickness >= TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS &&
        thickness.toString().length <= 3
      ) {
        thicknessIsValid = true
      }

      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitInsulation: {
            ...state.configuration.toitInsulation,
            type: type,
            material: {
              ...material,
              thickness: thicknessIsValid ? thickness : material.thickness,
            },
          },
        },
      }
      return draft
    },
    setToitClimateType: (state, action: PayloadAction<any>) => {
      // const material = FE_MATERIALS.find(
      //   (material) =>
      //     material.id === ToitEnPenteMaterialMap[action.payload as ToitEnPenteClimateTypes]
      // )!
      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitClimate: {
            ...state.configuration.toitClimate,
            type: action.payload,
            // material: material,
            material: null,
          },
        },
      }
      return draft
    },
    setToitStructureType: (state, action: PayloadAction<any>) => {
      // const material = FE_MATERIALS.find(
      //   (material) =>
      //     material.id === ToitEnPenteMaterialMap[action.payload as ToitEnPenteStructureTypes]
      // )!
      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitStructure: {
            ...state.configuration.toitStructure,
            type: action.payload,
            // material: material,
            material: null,
          },
        },
      }
      return draft
    },
    setToitRainCoverType: (state, action: PayloadAction<any>) => {
      // const material = FE_MATERIALS.find(
      //   (material) =>
      //     material.id === ToitEnPenteMaterialMap[action.payload as ToitEnPenteRainCoverTypes]
      // )!
      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitRainCover: {
            ...state.configuration.toitRainCover,
            type: action.payload,
            // material: material,
            material: null,
          },
        },
      }
      return draft
    },
    setToitAcousticLayerType: (state, action: PayloadAction<any>) => {
      // const material = FE_MATERIALS.find(
      //   (material) =>
      //     material.id === ToitEnPenteMaterialMap[action.payload as ToitEnPenteAcousticLayerTypes]
      // )!
      const draft = {
        ...state,
        configuration: {
          ...state.configuration,
          toitAcousticLayer: {
            ...state.configuration.toitAcousticLayer,
            type: action.payload,
            // material: material,
            material: null,
          },
        },
      }
      return draft
    },

    setToitInsulationMaterial: (state, action: PayloadAction<FEMaterial>) => {
      const material = action.payload
      state.configuration.toitInsulation.material = material
      state.thermalPerformance = updateThermalLayer(
        state.thermalPerformance,
        material,
        "toitInsulation"
      )
    },

    setConfiguration(
      state,
      action: PayloadAction<ToitEnPenteConfigurationState>
    ) {
      state.configuration = action.payload
      state.thermalPerformance = getThermalPerformance(action.payload)
    },
    setHumanReadableName: (state, action: PayloadAction<string>) => {
      state.configuration.humanReadableName = action.payload
      state.thermalPerformance = getThermalPerformance(state.configuration)
    },
    setDownloadState: (state, action: PayloadAction<DownloadState>) => {
      state.download = action.payload
    },
    addScreenshot: (state, action: PayloadAction<string>) => {
      state.screenshots = [...state.screenshots, action.payload]
    },
    setOverviewScreenshot: (state, action: PayloadAction<string>) => {
      state.overviewScreenshot = action.payload
    },
  },
})
